module.exports = __webpack_public_path__ + "img/Invisibility.94924c23.svg";